import { render, staticRenderFns } from "./expertSurgeryDialog.vue?vue&type=template&id=7923be37&scoped=true"
import script from "./expertSurgeryDialog.vue?vue&type=script&lang=js"
export * from "./expertSurgeryDialog.vue?vue&type=script&lang=js"
import style0 from "./expertSurgeryDialog.vue?vue&type=style&index=0&id=7923be37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7923be37",
  null
  
)

export default component.exports